<template>
  <!-- Displays a list of products and a sidebar -->
  <Loading :loading="loading || wordpressLoading" class="row" id="listing">
    
    <!-- <ListingSidebar :allProducts="listingData" :products="products"/> -->
    <div class="col-12 col-md-10 offset-md-1">
      <div class="row">
        <Breadcrumbs/>
      </div>
      <div class="row">
        <WordpressContentPage
          pageSlug="brands-top"
          class="col-12"
          :showLoading="false"
          v-on:loaded="() => {wordpressLoading = false}"
        />
      </div>
      <div class="row">
        <!-- scrollTo is scroll point for pagination change-->
        <h1 id="scrollTo" class="col-auto listingTitle">{{listingName}}</h1>
      </div>
	<div class="row">
		<div class="sidebar col-md-2 col-12 px-md-0 px-4">
			<div class="sidebarInner">
				<SubsubcategoryFilter :products="products" :allProducts="listingData"/>
			</div>
		</div>
		<div class="col-12 col-md-10">
			<div class="row col-12 productListingOptions">
				<div class="col-12 col-md-4 showCount mb-2 mb-md-0 ">
					Show:
					<span
						v-for="option in showOptions"
						:key="option"
						@click="() => {itemsPerPage = option; pageNumber = 0;}"
						:class="{current: itemsPerPage == option}"
						class="displayOption"
					>
						<span class="displayOptionText">{{option == 10000 ? 'All' : option}}</span>
					</span>
				</div>
				<div class="sorting col-12 col-md-3 mb-3 mb-md-0 ">
					<span
						v-for="option in sortingOptions"
						:key="option[0]"
						@click="() => {sortingAlgo = option[0]; pageNumber = 0;}"
						:class="{current: sortingAlgo == option[0]}"
						class="displayOption"
					>
						<span class="displayOptionText">{{option[1]}}</span>
					</span>
				</div>
				<div class="col-12 col-md-5">
				<SearchBar :searchFunc="debounceSearch" ref="searchBar" placeholder="Search Brands" />
				</div>
			</div>
			<div class="row">
				<div v-if="products.length > 0" class="col-12">
				<transition-group
					name="fade"
					type="out-in"
					tag="div"
					class="row itemContainer align-items-center"
					appear
				>
					<div v-for="product in products" class="col-6 col-md-4 col-lg-3 discountPartnerItem" :key="product.id">
					<div class="row">
						<div class="col-12">
						<img v-if="product.images" :src="imageUrl(product.images[0].sizes, 'small')" :alt="product.title + ' Logo'">
						</div>
						<div class="col-12 text-center textRed itemTitle">
							<router-link
							:to="{name:'brand', params:{brand: product.id, source: 'brands'}, query:{backRoute: $route.fullPath, from: 'All Brands'}}"
							class="noStyle"
							>{{product.title}}
							</router-link>
						</div>
					</div>
					</div>
				</transition-group>
				<PaginationButtons :pageNumber="pageNumber" :pageCount="pageCount"/>
			</div>
			<div v-else class="col-12 text-center my-3">
			<p>We couldn't find any Brands matching your search</p>
			<p>Try clearing your filters</p>
			<ClearFiltersButton class="btn btn-primary" :extraFunc="() => {this.search = ''; this.$refs.searchBar.clear()}"/>
			</div>
		</div>
	</div>

      </div>
    </div>
    <vue-headful title="Brands | Cherrytree'"/>
  </Loading>
</template>

<script>
import { mapState } from "vuex";
import { fetchBrands, getRestrictedBrands } from "@/network/brandRequests";

import SubsubcategoryFilter from "@/sections/shop/listing/ListingSidebarSubSubCategoryFilter";

import Breadcrumbs from "@/components/breadcrumbs/Breadcrumbs";
import Loading from "@/components/loading/Loading";

import PaginationButtons from "@/components/paginationButtons";

import { filterListing } from "@/sections/shop/listing/filterListing";

import { imageUrl } from "@/utils";

import SearchBar from "@/components/searchBar";

import ClearFiltersButton from "@/components/buttons/ClearFiltersButton";
import WordpressContentPage from "@/wordpress/WordpressContentPage";

export default {
  name: "ProductListing",
  components: {
    PaginationButtons,
    Loading,
    // ListingSidebar,
    SubsubcategoryFilter,
    Breadcrumbs,
    ClearFiltersButton,
    WordpressContentPage,
    SearchBar
  },
  data: () => {
    return {
      search: "",
      listingData: [], //will hold data about listing
      loading: false,
      itemsPerPage: 48, //default
      sortingAlgo: "TitleAZ", //sort A-Z by default
      wordpressLoading: true,
      searchTimeout: null
    };
  },
  //called every time the before component is shown
  created() {
    this.getData();
  },
  methods: {
    imageUrl,
    getData() {
      this.loading = true;
      fetchBrands(
        listing => {
          this.listingData = Object.values(listing);
          this.loading = false;
        },
        error => {
          console.log(error);
        }
      );
    },
    debounceSearch(val){
      if(this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.search = val
      }, 150);
    },
  },
  watch: {
    //check if the items have changed and if they have then reset pagination to 0
    filtered: function(oldItems, newItems) {
      if (oldItems.length == newItems.length) {
        for (let i = 0; i < oldItems.length; i++) {
          if (oldItems[i] != newItems[i]) {
            this.pageNumber = 0;
            return;
          }
        }
      } else {
        this.pageNumber = 0;
      }
    },
    // check if category/subcategory has changed and fetch new data if so
    "$route.params"(oldVal, newVal) {
      if (oldVal.toString() == newVal.toString()) {
        return;
      }
      this.getData();
    }
  },
  computed: {
    ...mapState({
      // map categories to store.reference.categories
      categories: state => state.reference.categories,
      memberLevel: state => state.auth.memberLevel
    }),
    restrictedBrands(){
      if(this.memberLevel == "silver" || this.memberLevel == "public" ){
        return getRestrictedBrands
      }
      else{
        return []
      }
    },
    listingId() {
      return this.$route.params.subcategory;
    },
    filtered() {
      //setup refine id
      let { priceHigh, priceLow, brand, refine } = this.$route.query;
      let search = this.search;
      let price_key = "member_price";

      return filterListing(
        this.listingData,
        priceHigh,
        priceLow,
        brand,
        refine,
        search,
        null,
        price_key
      );
    },
    sortingOptions() {
      let options = [];

      options.push(["TitleAZ", "A-Z"]);
      options.push(["TitleZA", "Z-A"]);

      return options;
    },
    sorted() {
      let sortingAlgo = () => {};

      try {
        switch (this.sortingAlgo) {
          case "TitleAZ":
            sortingAlgo = (a, b) => a.title.localeCompare(b.title);
            break;
          case "TitleZA":
            sortingAlgo = (a, b) => b.title.localeCompare(a.title);
            break;
          default:
            throw new Error(
              "Invalid sorting algorithm " + this.sortingAlgorithm
            );
        }
        return this.filtered.slice().sort(sortingAlgo); //make copy before sorting
      } catch {
        console.error("error sorting ", this.sortingAlgo);
        return this.filtered;
      }
    },
    paginated() {
      const start = (this.pageNumber - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.sorted.slice(start, end);
    },
    pageCount() {
      let l = this.filtered.length,
        s = this.itemsPerPage;
      return Math.ceil(l / s);
    },
    pageNumber: {
      get() {
        if (this.$route.query && this.$route.query.page) {
          return parseInt(this.$route.query.page);
        }
        return 1;
      },
      //when page number is set, update query param in route
      set(val) {
        // eslint-disable-next-line
        const { page, ...oldQuery } = this.$route.query;
        if (val === 0 || val === undefined || val === 1) {
          //remove page from query params if page number is 0
        //   this.$router.push({ query: { ...oldQuery } });
        } else {
          this.$router.push({ query: { page: val, ...oldQuery } });
        }
      }
    },
    products() {
      return this.paginated;
    },
    brands() {
      var listingArray = Object.values(this.listingData);
      return listingArray.filter(listing => {
        return parseFloat(listing.retail_price) == 0;
      });
    },
    listingName() {
      const catId = 1635;
      const subcatId = this.$route.params.location;
      if (!catId || !subcatId || !this.categories) {
        return "";
      }
      return this.categories[catId].children[subcatId].category;
    },
    showOptions() {
      let options = [12, 24, 48, 100, 1000];
      return options;
    },
  }
};
</script>

<style lang="scss" scoped>
.listingTitle {
  padding: 5px;
  padding-left: 30px;
}

.itemContainer {
  overflow: hidden;
}

.productListingOptions {
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 0.8em;
}

.displayOption {
  &:not(:last-of-type)::after {
    content: " - ";
  }
}

.displayOptionText {
  cursor: pointer;
}

.displayOption.current .displayOptionText {
  text-decoration: underline;
}

.discountPartnerItem {
  padding: 20px;
}

.itemTitle {
  font-size:1.3em;
  a:hover {
    text-decoration: underline;
  }
}

.backToParent {
  display: inline-block;
  margin-left: 20px;
}

.discountPartnerItem {
  img {
    max-width: 100%;
    height: auto;
  }
  .description img {
    display: none;
  }
}

.offerText {
  font-weight: bold;
  color: $CTred;
  font-size: 1.6em;
  margin-bottom: 10px;
}
</style>
